import { BaseModel } from '~/models/baseModel';

export class AwexModel extends BaseModel {
    public indicatorId:string;
    public price:string;
    public diff:string;
}
